<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-3"><a id="page_xvi"><em>Abbreviations</em></a></h1><a id="page_xvi">
<table>
<tbody>
<tr>
<td class="abb1">
<p class="t-left"><em>BAR</em></p></td>
<td class="abb2">
<p class="t-left"><em>Biblical Archaeology Review</em></p></td>
</tr>
<tr>
<td class="abb1">
<p class="t-left"><em>BBR</em></p></td>
<td class="abb2">
<p class="t-left"><em>Bulletin for Biblical Research</em></p></td>
</tr>
<tr>
<td class="abb1">
<p class="t-left"><em>BSac</em></p></td>
<td class="abb2">
<p class="t-left"><em>Bibliotheca Sacra</em></p></td>
</tr>
<tr>
<td class="abb1">
<p class="t-left"><em>CBQ</em></p></td>
<td class="abb2">
<p class="t-left"><em>Catholic Biblical Quarterly</em></p></td>
</tr>
<tr>
<td class="abb1">
<p class="t-left"><em>CovQ</em></p></td>
<td class="abb2">
<p class="t-left"><em>Covenant Quarterly</em></p></td>
</tr>
<tr>
<td class="abb1">
<p class="t-left"><em>CTJ</em></p></td>
<td class="abb2">
<p class="t-left"><em>Calvin Theological Journal</em></p></td>
</tr>
<tr>
<td class="abb1">
<p class="t-left"><em>EvQ</em></p></td>
<td class="abb2">
<p class="t-left"><em>Evangelical Quarterly</em></p></td>
</tr>
<tr>
<td class="abb1">
<p class="t-left"><em>JBL</em></p></td>
<td class="abb2">
<p class="t-left"><em>Journal of Biblical Literature</em></p></td>
</tr>
<tr>
<td class="abb1">
<p class="t-left"><em>JETS</em></p></td>
<td class="abb2">
<p class="t-left"><em>Journal of the Evangelical Theological Society</em></p></td>
</tr>
<tr>
<td class="abb1">
<p class="t-left"><em>JSOT</em></p></td>
<td class="abb2">
<p class="t-left"><em>Journal for the Study of the Old Testament</em></p></td>
</tr>
<tr>
<td class="abb1">
<p class="t-left"><em>NIB</em></p></td>
<td class="abb2">
<p class="t-left"><em>The New Interpreter’s Bible</em></p></td>
</tr>
<tr>
<td class="abb1">
<p class="t-left">NIBC</p></td>
<td class="abb2">
<p class="t-left">New International Bible Commentary</p></td>
</tr>
<tr>
<td class="abb1">
<p class="t-left">NICOT</p></td>
<td class="abb2">
<p class="t-left">New International Commentary on the Old Testament</p></td>
</tr>
<tr>
<td class="abb1">
<p class="t-left"><em>NIDOTTE</em></p></td>
<td class="abb2">
<p class="t-left"><em>New International Dictionary of Old Testament Theology and Exegesis</em></p></td>
</tr>
<tr>
<td class="abb1">
<p class="t-left"><em>TDOT</em></p></td>
<td class="abb2">
<p class="t-left"><em>Theological Dictionary of the Old Testament</em></p></td>
</tr>
<tr>
<td class="abb1">
<p class="t-left"><em>TynBul</em></p></td>
<td class="abb2">
<p class="t-left"><em>Tyndale Bulletin</em></p></td>
</tr>
<tr>
<td class="abb1">
<p class="t-left"><em>VT</em></p></td>
<td class="abb2">
<p class="t-left"><em>Vetus Testamentum</em></p></td>
<td class="abb2"></td>
</tr>
<tr>
<td class="abb1">
<p class="t-left"><em>WW</em></p></td>
<td class="abb2">
<p class="t-left"><em>Word and World</em></p></td>
</tr>
</tbody>
</table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008_Abbreviations.vue?56c15ec1